import { Component } from '@angular/core';
import { RouterService } from 'src/app/services/router-service.service';
import { ContactService } from 'src/app/services/contact.service';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
	year : number;

	constructor(public routerService:RouterService,
				public contact:ContactService) {
		this.year = new Date().getFullYear();
	}
}
